<section class="relative">
    <ui-m000-c010-image
        class="relative h-full"
        classList="h-full w-full aspect-[767/1432] md:aspect-[1023/896] lg:min-h-[475px] lg:aspect-[1440/600] 2xl:aspect-[1920/600]"
        [image]="{
            image: backgroundImageUrl()['2xl'],
            desktop2xl: { width: 1920, height: 600 },
            desktop: { width: 1440, height: 600, url: backgroundImageUrl()['lg'] },
            tablet: { width: 1023, height: 896, url: backgroundImageUrl()['md'] },
            mobile: { width: 767, height: 1432, url: backgroundImageUrl()['mobile'] },
        }"
        [priority]="true"
        [alt]="altBackgroundImage()"
        [cover]="true"
        [highRes]="true"
    />
    <div
        class="absolute bottom-24 left-1/2 w-full max-w-[calc(100vw-48px)] -translate-x-1/2 md:bottom-0 xl:max-w-[1216px]"
    >
        <div class="bg-white text-black transition-colors md:max-w-[584px]">
            <div
                class="inner-page-wrapper flex flex-col px-16 pt-24 pb-32 lg:px-24 lg:pt-24"
                [ngClass]="{ 'border-grey-200 border-b': isHWS && !hasKeyPromotionBanner() }"
            >
                <ng-content select="[title]" />
                <div
                    class="mb-8 flex items-center justify-start overflow-x-auto pt-24 pb-8 md:justify-center lg:justify-between lg:pt-16"
                >
                    @if (showQuickFilter()) {
                        <div class="flex justify-center gap-20">
                            <button
                                class="button__condition light lg:text-[18px]"
                                [class.button__condition--active]="!selectedCondition() && !selectedHotDeal()"
                                (click)="removeAllFilters()"
                            >
                                Alle
                            </button>
                            <button
                                class="button__condition light lg:text-[18px]"
                                [class.button__condition--active]="selectedCondition()?.includes('Neufahrzeug')"
                                (click)="toggleFilter('condition', ['Neufahrzeug'], 'Neuwagen', 'hotDeal')"
                            >
                                Neuwagen
                            </button>
                            <button
                                class="button__condition light lg:text-[18px]"
                                [class.button__condition--active]="selectedCondition()?.includes('Gebrauchtfahrzeug')"
                                (click)="
                                    toggleFilter('condition', ['Gebrauchtfahrzeug'], 'Gebrauchtfahrzeug', 'hotDeal')
                                "
                            >
                                Gebrauchtwagen
                            </button>
                            <button
                                class="button__condition light lg:text-[18px]"
                                [class.button__condition--active]="selectedHotDeal()"
                                (click)="toggleFilter('hotDeal', true, 'Angebote', 'condition')"
                            >
                                Angebote
                            </button>
                        </div>
                    }
                </div>

                <div class="contents grid grid-cols-1 gap-16">
                    <div class="flex-1">
                        <div class="grid grid-cols-1 gap-16 lg:grid-cols-2">
                            <ui-input-select
                                class="lg:flex-1"
                                [options]="models()"
                                theme="light"
                                (selectedObjChanged)="
                                    $event ? addFilter('model', [$event.value], $event.label) : removeFilter('model')
                                "
                                withNullSelect
                                label="Modell"
                                placeholder="Modell auswählen"
                                nullSelectCustomLabel="Alle Modelle"
                                ariaLabel="Modell auswählen"
                            />
                            <ui-input-select
                                class="lg:flex-1"
                                [options]="price()"
                                theme="light"
                                (selectedObjChanged)="
                                    $event
                                        ? addFilter('price', { max: $event.value }, `bis ${$event.label}`)
                                        : removeFilter('price')
                                "
                                withNullSelect
                                nullSelectCustomLabel="Beliebiger Preis"
                                label="Preis bis"
                                placeholder="Preis auswählen"
                                ariaLabel="Preis auswählen"
                            />
                            <ui-input-select
                                class="lg:flex-1"
                                [options]="milage()"
                                theme="light"
                                (selectedObjChanged)="
                                    $event
                                        ? addFilter('mileage', { max: $event.value }, `bis ${$event.label}`)
                                        : removeFilter('mileage')
                                "
                                withNullSelect
                                label="Kilometer bis"
                                placeholder="Kilometer auswählen"
                                nullSelectCustomLabel="KM beliebig"
                                ariaLabel="Kilometer auswählen"
                            />
                            <div class="hidden lg:block">
                                <ng-template [ngTemplateOutlet]="cta" />
                            </div>
                            <div class="hidden lg:block"></div>
                            <div class="hidden items-end lg:flex lg:flex-col lg:gap-16">
                                @if (vehicleCount() === 0) {
                                    <lib-search-abo-button theme="light" [isBigButton]="false" />
                                }
                                <ng-template [ngTemplateOutlet]="filterCta" />
                            </div>
                        </div>
                        <div class="hidden lg:block">
                            <ng-template [ngTemplateOutlet]="quickfilterEntries" />
                        </div>
                    </div>

                    <div class="mt-8 flex flex-col-reverse items-end gap-24 lg:hidden">
                        <ng-template [ngTemplateOutlet]="cta" />
                        <ng-template [ngTemplateOutlet]="filterCta" />
                    </div>

                    <div class="flex flex-col lg:hidden">
                        @if (vehicleCount() === 0) {
                            <lib-search-abo-button class="mt-8 ml-auto" theme="light" [isBigButton]="false" />
                        }
                        <ng-template [ngTemplateOutlet]="quickfilterEntries" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #quickfilterEntries>
    @if (staticFilterHistorys(); as historys) {
        @if (historys && historys.length) {
            <div class="bg-grey-300 mt-24 hidden h-1 w-full lg:block"></div>
            <div class="pt-24 md:pt-12">
                <p class="font-headline text-16 mb-8 leading-20">
                    Ihre {{ historys.length === 1 ? 'letzte Suche' : 'letzten Suchen' }}:
                </p>
                <div class="flex flex-col items-start justify-start gap-8 lg:flex-row lg:items-center lg:gap-16">
                    @for (entry of staticFilterHistorys(); track entry.filter) {
                        <a
                            class="bg-accent group text-14 flex items-center gap-8 px-8 py-4 leading-20 text-white"
                            [queryParams]="{ filter: entry.filter }"
                            [hyundaiRouterLink]="listLink()"
                            (click)="trackSubmitFilter(); trackQuickfilter()"
                        >
                            <span>{{ entry.name }}</span>
                            <i class="icon-chevron-right group-hover:animate-bouncing-left"></i>
                        </a>
                    }
                </div>
            </div>
        }
    }
</ng-template>

<ng-template #cta>
    <a
        class="button-primary transition-colors"
        [queryParams]="{ filter: filterParam() }"
        [hyundaiRouterLink]="listLink()"
        (click)="trackSubmitFilter(); addQuickfilter()"
    >
        <span class="mr-8">
            @if (loadingPreviewNumberOfVehicles()) {
                <div class="size-[18px] animate-spin rounded-full border-2 border-transparent border-l-white"></div>
            } @else {
                {{ vehicleCount() | number }}
            }
        </span>
        <span>Fahrzeuge anzeigen</span>
    </a>
</ng-template>

<ng-template #filterCta>
    <button class="font-headline text-16 text-accent flex items-center gap-8 leading-20" (click)="openFilterDialog()">
        <i class="icon-filter"></i>
        Erweiterter Filter
    </button>
</ng-template>
